var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/user"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 12.75C8.83 12.75 6.25 10.17 6.25 7C6.25 3.83 8.83 1.25 12 1.25C15.17 1.25 17.75 3.83 17.75 7C17.75 10.17 15.17 12.75 12 12.75ZM12 2.75C9.66 2.75 7.75 4.66 7.75 7C7.75 9.34 9.66 11.25 12 11.25C14.34 11.25 16.25 9.34 16.25 7C16.25 4.66 14.34 2.75 12 2.75Z",
    fill: "#B0BECF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M20.5862 22.75C20.1762 22.75 19.8362 22.41 19.8362 22C19.8362 18.55 16.3162 15.75 11.9962 15.75C7.67625 15.75 4.15625 18.55 4.15625 22C4.15625 22.41 3.81625 22.75 3.40625 22.75C2.99625 22.75 2.65625 22.41 2.65625 22C2.65625 17.73 6.84625 14.25 11.9962 14.25C17.1462 14.25 21.3362 17.73 21.3362 22C21.3362 22.41 20.9962 22.75 20.5862 22.75Z",
    fill: "#B0BECF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.f17847de732cdcff52702e48d9f53e6f.svg";
export { ForwardRef as ReactComponent };